// Frontend/src/app/private/cajero/cajero.component.ts
import { Component } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent} from '../../core/components/sidebar/sidebar.component';
import {NzIconDirective} from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-cajero',
  standalone: true,
  imports: [NzLayoutModule, RouterOutlet, SidebarComponent, NzIconDirective],
  templateUrl: './cajero.component.html',
  styleUrls: ['./cajero.component.css']
})
export class CajeroComponent {
  isCollapsed = false;
}
